import { Recipe } from "./Recipe";

//25-04-24  Changed for prep_var functionality
//export const AddRecipeFormTemplate = Object.freeze({

export const AddRecipeFormTemplate = (handleBlurInPrepVar) => {
  //function that handles onBlur event in order to add prep_var to D&D
  Recipe.prep_var.onBlur = handleBlurInPrepVar;

  return {
    sections: [
      {
        //title: "Detalles",
        size: 1 / 2,
        compact: true,
        inputs: [
          Recipe.difficulty,
          Recipe.cook_time,
          Recipe.cook_type,
          Recipe.prep_var,
          Recipe.dish_type,
          Recipe.suited_meal,
          Recipe.cuisine,
          Recipe.cook_aux,
          Recipe.season,
          Recipe.week_day,
          Recipe.max_week_prep,
          /*  Recipe.rep_group_var, */
          Recipe.nutrient_group,
          Recipe.portable,
        ],
      },
    ],
  };
};
